import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import AboutStory from "../Components/AboutStory";
import Footer from "../Components/Footer";
import WhyChooseUs from "../Components/WhyChooseUs";
import bgwhite from "../Images/Frame.png";
import about from "../Images/mission1.png";
import bgteal from "../Images/tealback.png";
import team5 from "../Images/TeamMembersImages/ahmed.png";
import team from "../Images/TeamMembersImages/ceo.png";
import team6 from "../Images/TeamMembersImages/fatima.png";
import team3 from "../Images/TeamMembersImages/jabbar.png";
import team1 from "../Images/TeamMembersImages/marriam.png";
import team2 from "../Images/TeamMembersImages/moiz.png";
import team4 from "../Images/TeamMembersImages/umer.png";

const AboutPage = () => {
  const [missionInView, setMissionInView] = useState(false);

  const { ref: missionRef, inView } = useInView({
    threshold: 0.3,
    onChange: (inView) => {
      setMissionInView(inView);
    },
  });

  const team_arr = [
    {
      name: "Adnan Taj",
      role: "CEO",
      team: team,
    },
    {
      name: "Marrium Bilal",
      role: "Managing Director",
      team: team1,
    },
    {
      name: "Abdul Moiz",
      role: "Digital Marketer",
      team: team2,
    },
    {
      name: "Usman",
      role: "Digital Marketer",
      team: team3,
    },
    {
      name: "Umer Akram",
      role: "Branding Expert",
      team: team4,
    },
    {
      name: "Ahmed Raza",
      role: "Backend developer",
      team: team5,
    },
    {
      name: "Fatima Bilal",
      role: "Frontend Developer",
      team: team6,
    },
  ];

  return (
    <div
      className="lg:snap-y lg:snap-mandatory overflow-y-scroll h-screen"
      style={{
        backgroundImage: `url(${bgteal})`,
        backgroundSize: "cover",
        backgroundPosition: "top left",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed", // Fix background movement
      }}
    >
      {/* AboutStory Section */}
      <section className="lg:h-screen md:h-screen snap-start items-center justify-center ">
        <AboutStory />
      </section>

      {/* Mission Section */}
      <section
        className="lg:h-screen md:h-screen snap-start flex flex-col md:flex-row items-center bg-white text-gray-600"
        style={{
          backgroundImage: `url(${bgwhite})`,
          backgroundSize: "cover",
          backgroundPosition: "top left",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed", // Fix background movement
        }}
      >
        <div className="md:block flex-1">
          
          <img
            ref={missionRef}
            src={about}
            alt="Our Mission"
            className={`w-full h-auto max-w-xs md:max-w-sm lg:max-w-lg duration-500 ease-out mx-auto ${
              missionInView ? "scale-75 opacity-100" : "opacity-75 scale-0"
            }`}
          />
          
        </div>
        <div className="w-full md:w-1/2 p-4 md:p-10 text-center md:text-left">
          <h2 className="text-3xl md:text-4xl lg:text-5xl text-teal-950 font-bold mb-2 md:mb-6">
            <span className="font-bold text-teal-500 text-3xl md:text-4xl lg:text-5xl">
              Our Mission
            </span>
          </h2>
          <p className="text-lg md:text-lg lg:text-xl mr-0 md:mr-10 lg:mr-16 mb-4 md:mb-0">
            To deliver innovative and impactful marketing solutions that elevate
            brands, drive engagement, and achieve measurable results in a
            dynamic digital landscape.
          </p>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="lg:h-screen md:h-screen snap-start">
        <WhyChooseUs />
      </section>
      {/* Footer */}
      <div className="snap-start">
        <Footer />
      </div>
    </div>
  );
};

export default AboutPage;
